
export default {
  methods: {
    can (key) {
      return this.$store.getters['user/can'](key)
    },
  },
}
